import React from 'react';
import { IconProps } from '../types/types';

const GASNEO: React.FC<IconProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 333.91 373.02" role="img" {...props}><g data-name="Layer 2"><g data-name="Layer 1"><g data-name="Layer 2"><path style={{fill: 'none', stroke: '#01e397', strokeMiterlimit: '10', strokeWidth: '16.27px'}} d="m325.74 61.75-158.8 59.1v240.6l-158.81-57V70.05l167.5-61.4 149.31 53.4.8 241.8-159-58.9" data-name="Layer 1-2"/></g></g></g></svg>
);

export default GASNEO;
